module.exports = __webpack_public_path__ + "img/galery8.1966ec00.jpg";